<section
  *ngIf="
    isPortfolioCorporate &&
    (accountManagerName || accountManagerPhone || accountManagerEmail)
  "
>
  <div class="d-flex no-gutters justify-content-end">
    <div class="block">
      <p class="block-title mb-0">Account Officer</p>
      <p class="mb-0" *ngIf="accountManagerName">{{ accountManagerName }} |</p>
      <p class="mb-0" *ngIf="accountManagerPhone">
        Tel:
        {{ accountManagerPhone }} |
      </p>
      <p class="mb-0" *ngIf="accountManagerEmail">
        {{ accountManagerEmail }}
      </p>
    </div>
  </div>
</section>
